export const environment = {
  production: false,
  apiUrl: 'https://diario.singleclick.co/api',
  wordpressUrl: 'https://wpdiario.singleclick.co',
};
